var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"badge badge-pill",class:{
      'badge-soft-light': _vm.isChatStatusNew,
      'badge-soft-primary': _vm.isChatStatusChat,
      'badge-soft-success': _vm.isChatStatusResolved,
    }},[(_vm.isChatStatusNew)?[_vm._v(" "+_vm._s(_vm.$t('room.status.new'))+" ")]:(_vm.isChatStatusChat)?[_vm._v(" "+_vm._s(_vm.$t('room.status.chat'))+" ")]:(_vm.isChatStatusResolved)?[_vm._v(" "+_vm._s(_vm.$t('room.status.resolved'))+" ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }